import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    TableContainer,
    ClickAwayListener,
    Checkbox,
    styled,
    Switch,
    CircularProgress,
    Tooltip,
    tooltipClasses,
} from "@mui/material";
import Header from '../partials/header';
import LeftSidebar from '../partials/leftSidebar';
import search from "../../assets/images/icon/search.svg"
import "./orders.css"
import { useNavigate } from "react-router-dom";
import { getMethod, putMethod } from "../../services/apiService";
import { Link } from "react-router-dom";
import { usePartnerIdContext  } from "../../context/partnerIdContext";
import filterIcon from "../../assets/images/icon-searchFilter.svg";
import iconDownArrow from "../../assets/images/icon-dropdown.svg";
import { ToastContext, useToastContext } from "../../context/toastContext";
import { PROFILE_TYPE } from "../../helper/globalConstant";

// const StyledSelect = styled(Select)({
//     "&.MuiOutlinedInput-root": {
//       "&:hover fieldset": {
//         outline: "none",
//         border: "none",
//         boxShadow: "none",
//       },
//       "&.Mui-focused fieldset": {
//         outline: "none",
//         border: "none",
//         boxShadow: "none",
//       },
//     },
//     "& .MuiSelect-select:focus": {
//       outline: "none",
//       border: "none",
//       boxShadow: "none",
//     },
//     "& .MuiSelect-icon": {
//       display: "none",
//     },
//   });

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 40, // Slightly smaller width for the switch
    height: 24, // Slightly smaller height for the switch
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: "14px", // Slightly smaller thumb size
        height: "14px", // Slightly smaller thumb size
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 4, // Adjusted padding for a smaller thumb
      "&.Mui-checked": {
        transform: "translateX(16px)", // Adjusted translation for smaller switch
        color: "#1F2F34",
        "& .MuiSwitch-thumb": {
          backgroundColor: "#1E2121", // Make the thumb black when enabled
        },
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#17B2EB",
          border: "1.5px solid #17B2EB", // Thicker border on active state
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: "14px", // Slightly smaller thumb size
      height: "14px", // Slightly smaller thumb size
      margin: "1px", // Adjusted margin to center the thumb
      borderRadius: "50%", // Ensuring the thumb remains perfectly round
      boxShadow: "none",
      transition: theme.transitions.create(["width"], {
        duration: 300,
      }),
    },
    "& .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "transparent",
      boxSizing: "border-box",
      border: "1.5px solid var(--text-text-tertiary, #A5A8A9)",
      borderRadius: 24 / 2, // Adjusted border radius for the smaller track
    },
  }));

const CustomTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#03171F',
        color: '#E2E3E3',
        fontSize: '12px',
        padding: '4px 12px',
        borderRadius: '50px',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#03171F',
    },
}));


export default function OrdersMain() {

    const [allOrders, setAllOrders] = useState<any[]>([]);
    const { partnerId, setPartnerId } = usePartnerIdContext();
    const { setToast } = useToastContext() as ToastContext;
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [loader, showLoader] = useState(true);

    const [openFilter, setOpenFilter] = useState(false);
    const filterOptions = [
        { label: "Customer", key: "vEnterprise.name" },
        { label: "Site / Devices", key: "vSite.name" },
        { label: "Order Name", key: "vSiteOrder.orderName" },
    ];

    useEffect(() => {
        if(partnerId) fetchOrderList();
    }, [partnerId]);

    const fetchOrderList = async () => {
        let partnerInfo
        const sess_user_data = localStorage.getItem("sess_user");
        if (sess_user_data != null) {
            try {
                const sess_user = JSON.parse(sess_user_data);
                const extractedProfileId = sess_user?.userProfile;
                if (extractedProfileId) {
                const priority = extractedProfileId?.priority;
                if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
                    partnerInfo = extractedProfileId?.ownerId;
                } else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR){
                    partnerInfo = partnerId
                }
                } else {
                    console.error("Priority id not found in userProfile");
                }
            } catch (error) {
                console.error("Error parsing session user data:", error);
            }
        }
        const resp = await getMethod(`customer/order/partnerid/${partnerInfo}`);        
        if(resp?.data?.code === 200) {
            setAllOrders(resp?.data?.result);
            setFilteredData(resp?.data?.result);
            showLoader(false);
        } else {
            showLoader(false);
        }
    }

    const navigate = useNavigate();

    const handleRowClick = (order: any) => {
        navigate("/orders/details", { state: { order } });
    };




    function convertTimestampToDate(timestamp: number): string {
        const formattedDate = new Date(timestamp).toLocaleString();
        return formattedDate.replace(',', '  |');
    }
    
    const [searchText, setSearchText] = useState("");
    const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
    const [sortedData, setSortedData] = useState([...allOrders]);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchText = e.target.value.toLowerCase();
        setSearchText(searchText);

        const filtered = allOrders?.filter((item: any) => {
            const enterpriseName = item.vEnterprise?.name?.toLowerCase() || "";
            const siteName = item.vSite?.name?.toLowerCase() || "";
            const centralUserEmail = item.vCentralUsers?.[0]?.mailId?.toLowerCase() || "";
            const siteOrderName = item.vSiteOrder?.orderName?.toLowerCase() || "";
            const licenseName = item.license?.data?.name?.toLowerCase() || "";

            return (
                enterpriseName.includes(searchText) ||
                siteName.includes(searchText) ||
                centralUserEmail.includes(searchText) ||
                siteOrderName.includes(searchText) ||
                licenseName.includes(searchText)
            );
        });

        setFilteredData(filtered); // Update the filtered data state
    };

     
    const handleSortChange = (option: string) => {
        const newFilter = option === selectedFilter ? null : option; 
        setSelectedFilter(newFilter);

        if (!newFilter) {
            //setSortedData([...allOrders]); 
            setFilteredData([...allOrders]);
            return;
        }
        const sorted = [...allOrders]?.sort((a: any, b: any) => {
            const valueA = getNestedValue(a, newFilter)?.toLowerCase() || "";
            const valueB = getNestedValue(b, newFilter)?.toLowerCase() || "";

            return valueA.localeCompare(valueB); 
        });

        //setSortedData(sorted);
        setFilteredData(sorted);
    };

    const getNestedValue = (obj: any, path: string) => {
        return path.split(".").reduce((acc, key) => acc?.[key], obj);
    };


    const handleOrderStatus = async (orderId: string, new_status: any) => {
        if (orderId) {
            const payload = {
                orderId: orderId,
                status: new_status,
            }
            const resp = await putMethod('customer/order/status', payload);
            if (resp?.data?.code === 200) {
                setAllOrders((prevOrders: any[]) =>
                    prevOrders.map((item) =>
                        item?.vSiteOrder?.orderId === orderId
                            ? {
                                ...item,
                                vSiteOrder: {
                                    ...item.vSiteOrder,
                                    status: new_status,
                                },
                            }
                            : item
                    )
                );
                setFilteredData((prevOrders: any[]) =>
                    prevOrders.map((item) =>
                        item?.vSiteOrder?.orderId === orderId
                            ? {
                                ...item,
                                vSiteOrder: {
                                    ...item.vSiteOrder,
                                    status: new_status,
                                },
                            }
                            : item
                    )
                );
                setToast("Order status updated successfully!", "success");
            } else {
                setToast("Failed to update the order status!", "error");
            }
        } 
    }


    return (
        <>
            <Box sx={{ display: 'flex' }}>

                <Header title="All Orders" />
                <LeftSidebar />

                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                        marginTop: 8,
                        padding: '0',
                    }}
                >
                    <Box sx={{ display: "flex", alignContent: "space-between", justifyContent: "space-between", gap: "32px", padding: "1rem" }}>
                        <div
                            style={{
                                width: 468,
                                height: 41,
                                padding: 12,
                                borderRadius: 30,
                                border: "1px solid #5a5f60",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                background: "#1F2F34",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <img
                                    src={search}
                                    alt="Search Icon"
                                    style={{ cursor: "pointer" }}
                                />
                                <input
                                    onChange={handleSearch}
                                    placeholder="Search by customer name, site / device name, email ID, order name "
                                    style={{
                                        background: "#1F2F34",
                                        border: "none",
                                        padding: 0,
                                        margin: 0,
                                        marginLeft: 8,
                                        color: "#FFF",
                                        width: 410,
                                    }}
                                />
                            </div>
                        </div>

                        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                            <Box position="relative" display="inline-block">
                                <Box
                                    onClick={() => setOpenFilter(!openFilter)}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        cursor: "pointer",
                                        background: "#1F2F34",
                                        borderRadius: 15,
                                        width: 60,
                                        height: 40,
                                        padding: "8px",
                                    }}
                                >
                                    <Box position="relative" display="flex">
                                        <img src={filterIcon} alt="Filter Icon" style={{ marginLeft: "8px" }} />
                                        {selectedFilter  && (
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "1px",
                                                    right: 0,
                                                    background: "#0699CE",
                                                    width: "7px",
                                                    height: "7px",
                                                    borderRadius: "50%",
                                                }}
                                            ></span>
                                        )}
                                    </Box>
                                    <img src={iconDownArrow} alt="Down Arrow" style={{ marginRight: "8px" }}/>
                                </Box>

                                {/* Dropdown Menu */}
                                {openFilter && (
                                    <ClickAwayListener onClickAway={() => setOpenFilter(false)}>
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: "50px", 
                                                left: "0",
                                                background: "#1F2F34",
                                                borderRadius: "8px",
                                                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                                                padding: "10px",
                                                width: "150px",
                                                zIndex: 1000,
                                            }}
                                        >
                                            {filterOptions?.map((option, index) => (
                                                <Box key={index} display="flex" alignItems="center">
                                                    <Checkbox
                                                        checked={selectedFilter === option.key}
                                                        onChange={() => handleSortChange(option.key)}
                                                        sx={{ color: "#B4B7B8" }}
                                                    />
                                                    <span style={{ fontSize: "14px" }}>{option.label}</span>
                                                </Box>
                                            ))}
                                        </Box>
                                    </ClickAwayListener>
                                )}
                            </Box>

                            <Link to="/orders/create" style={{
                                textDecoration: "none",
                                color: "inherit",

                            }}>
                                <button className="add-btn" style={{ cursor: "pointer" }}>
                                    Create New Order
                                </button>
                            </Link>
                        </Box>
                    </Box>


                    <TableContainer component={Paper} sx={{ backgroundColor: "#03171f", padding: "1rem" }}>
                        <Table sx={{ backgroundColor: "#03171f", border: "1px solid #313838" }}>
                            {/* Table Header */}
                            <TableHead>
                                <TableRow style={{ borderBottom: "2px solid #313838" }}>
                                    <TableCell sx={{ color: "#E2E3E3", borderColor: "#313838", fontWeight: "500", fontSize: "16px" }}>Created On</TableCell>
                                    <TableCell sx={{ color: "#E2E3E3", borderColor: "#313838", fontWeight: "500", fontSize: "16px" }}>Customer</TableCell>
                                    <TableCell sx={{ color: "#E2E3E3", borderColor: "#313838", fontWeight: "500", fontSize: "16px" }}>Site / Devices</TableCell>
                                    <TableCell sx={{ color: "#E2E3E3", borderColor: "#313838", fontWeight: "500", fontSize: "16px" }}>Customer Email</TableCell>
                                    <TableCell sx={{ color: "#E2E3E3", borderColor: "#313838", fontWeight: "500", fontSize: "16px" }}>Order Name</TableCell>
                                    <TableCell sx={{ color: "#E2E3E3", borderColor: "#313838", fontWeight: "500", fontSize: "16px" }}>Status</TableCell>
                                </TableRow>
                            </TableHead>

                            {/* Table Body */}
                            <TableBody>
                                {filteredData?.length > 0 ? (
                                    filteredData?.map((order: any, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{ padding: 0, cursor: order?.vSiteOrder?.status === 1 ? "pointer" : "not-allowed" }}
                                            onClick={() => {
                                                if (order?.vSiteOrder?.status === 1) {
                                                    handleRowClick(order);
                                                }
                                            }}
                                        >
                                            <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}><p>{convertTimestampToDate(order?.vSiteOrder?.createdAt)}</p> </TableCell>
                                            <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>{order?.vEnterprise?.name}</TableCell>
                                            <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>{order?.vSite?.name}</TableCell>
                                            <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>{order?.vCentralUsers?.[0]?.mailId}</TableCell>
                                            <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                                <CustomTooltip title={order?.vSiteOrder?.orderName} arrow>
                                                    {order?.vSiteOrder?.orderName?.length > 50
                                                        ? order.vSiteOrder.orderName.slice(0, 50) + "..."
                                                        : order?.vSiteOrder?.orderName
                                                    }
                                                </CustomTooltip>
                                            </TableCell>
                                            <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                                <AntSwitch
                                                    checked={order?.vSiteOrder?.status === 1 ? true : false}
                                                    inputProps={{ "aria-label": "ant design" }}
                                                    onClick={(e: any) => {
                                                        e.stopPropagation();
                                                        const newStatus = e.target.checked ? 1 : 3;
                                                        handleOrderStatus(order?.vSiteOrder?.orderId, newStatus);
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow sx={{ background: '#192529' }}>
                                        <TableCell
                                            sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', textAlign: 'center' }}
                                            colSpan={9}
                                        >
                                            {loader ? (
                                                <CircularProgress color="primary" />
                                            ) : (
                                                "No Data!"
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </>
    )
}
